module.exports = __webpack_public_path__ + "d3418be52f7511408196a8802b5f3469.svg";